import { render, staticRenderFns } from "./addEmployee.vue?vue&type=template&id=bee55528&scoped=true"
import script from "./addEmployee.vue?vue&type=script&lang=ts"
export * from "./addEmployee.vue?vue&type=script&lang=ts"
import style0 from "./addEmployee.vue?vue&type=style&index=0&id=bee55528&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bee55528",
  null
  
)

export default component.exports